import React from 'react';
import { QueryClient } from 'react-query';

import { retryImportChunk } from '@savgroup-front-common/core/helpers/retryImportChunk';

export const QrcodeUploadPage = React.lazy(() =>
  retryImportChunk(
    () => import('@savgroup-front-common/core/components/QrcodeUpload'),
  ),
);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
